// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 576px) {
  .modal-dialog {
    max-width: 75%;
    margin: 1.75rem auto;
  }
}
.title-modal {
  font-size: 2rem;
  letter-spacing: -0.26px;
  font-weight: 200;
}

.sub-title-modal {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
}

.accordion * {
  color: #686868 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
